import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { RoleGroupMatchTypes, useHasRoleGroups } from 'hooks/useHasRoleGroups'
import { AddCustomer as AddEmbeddedCustomer } from 'pages/EmbeddedCustomers/AddCustomer/AddCustomer'
import { AddCustomer as AddNestedCustomer } from 'pages/NestedCustomers/components/AddCustomer/AddCustomer'
import { ROLES_REQUIRED_TO_ADD_CUSTOMER } from '../constants'
import { CustomerModel, CustomerModels } from '../helpers/types'

export interface AddCustomerCtaProps {
  customerModel: CustomerModel
  refetchCustomers: () => void
}

export const AddCustomerCta = ({ customerModel, refetchCustomers }: AddCustomerCtaProps) => {
  const { t } = useTranslation()
  const [isAddCustomerSheetOpen, setIsAddCustomerSheetOpen] = useState(false)
  const { profile } = useProfileContext()

  const canAddCustomer = useHasRoleGroups(
    profile,
    ROLES_REQUIRED_TO_ADD_CUSTOMER,
    RoleGroupMatchTypes.SOME
  )

  const onOpenAddNewCustomer = () => {
    if (!canAddCustomer) return
    setIsAddCustomerSheetOpen(true)
  }

  const onCloseAddNewCustomer = () => {
    setIsAddCustomerSheetOpen(false)
  }

  const onNewCustomerAdded = () => {
    refetchCustomers()
    onCloseAddNewCustomer()
  }

  return (
    <>
      <Button
        onClick={onOpenAddNewCustomer}
        name={t('customers.addNewCustomer')}
        iconElement={<Icon name="Plus" />}
        disabled={!canAddCustomer}
      >
        {t('customers.addNewCustomer')}
      </Button>
      {customerModel === CustomerModels.EMBEDDED ? (
        <AddEmbeddedCustomer
          isOpen={isAddCustomerSheetOpen}
          onClose={onCloseAddNewCustomer}
          onCustomerAdded={onNewCustomerAdded}
        />
      ) : (
        <AddNestedCustomer
          isSheetOpen={isAddCustomerSheetOpen}
          handleCloseSheet={onCloseAddNewCustomer}
          handleOnSuccessCloseSheet={onNewCustomerAdded}
        />
      )}
    </>
  )
}
